// extracted by mini-css-extract-plugin
export default {"about":"rRIWJTyduR","dark":"hxcGDS4f2O"};